<template>
    <div class="windowsApplicationClass">
      <div>
        <HeaderView />
      </div>
      <div>
        <WindowsApplicationA />
      </div>
      <div>
        <FooterView />
      </div>
    </div>
    </template>
    
    <script>
    import HeaderView from "@/components/HeaderView.vue";
    import FooterView from "@/components/FooterView.vue";
    import WindowsApplicationA from "@/components/ServicePages/WindowsApplicationPage/WindowsApplicationA.vue";
    
    export default {
      name: "ColorRain",
      components: {
        HeaderView,
        WindowsApplicationA,
        FooterView,
      },
    };
    </script>
    
    <style scoped>
    
    </style>
      